<template>
  <div class="base-div">
    <md-table-card>
      <md-input-container>
        <label style="left: 10px;">Search..</label>
        <md-input v-model="searchTitle" type="text" required></md-input>
      </md-input-container>
      <md-table>
        <md-table-header>
          <md-table-row>
            <md-table-head>Email</md-table-head>
            <md-table-head>Excel Sheet Lead Counts</md-table-head>
            <md-table-head>Date</md-table-head>
            <md-table-head>Date</md-table-head>
          </md-table-row>
        </md-table-header>

        <md-table-body>
          <md-table-row v-for="(row, rowIndex) in Items" :key="rowIndex" :md-item="row">
            <md-table-cell
              v-for="(column, columnIndex) in row"
              :key="columnIndex"
              v-if="columnIndex !== '_id'"
            >
              <span>{{ column }}</span>
            </md-table-cell>
            <!-- <md-table-cell>
							<md-button class="md-icon-button" @click="(e)=> edit(e, row, rowIndex)">
								<md-icon>edit</md-icon>
							</md-button>
            </md-table-cell>-->
          </md-table-row>
        </md-table-body>
      </md-table>
      <md-table-pagination
        :mdTotal="MaxResult"
        :mdSize="End"
        :mdPage="Current"
        :mdPageOptions="Limit"
        @pagination="onPagination"
        @size="onSizeChange"
      ></md-table-pagination>
      <md-dialog-confirm
        ref="confirm_dailog"
        :md-title="error.title"
        :md-content-html="error.message"
        :md-ok-text="error.okText"
        :md-cancel-text="error.cancelText"
        @open="onOpen"
        @close="onClose"
      ></md-dialog-confirm>
    </md-table-card>
  </div>
</template>


<script>
import { makeRequest } from "../../../helper/internet";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/excelsheelogs");
  },

  mounted() {
    if (
      this.$mcdStore.get("limitIndex") == undefined ||
      this.$mcdStore.get("limitIndex") == null
    ) {
      this.$mcdStore.set("limitIndex", 0);
    }
    this.options.current = this.$store.getters.appPreviousPage;
    this.options.end = this.options.limit[this.$mcdStore.get("limitIndex")];
    this.getItems(1, () => {
      this.$store.dispatch("setIsProgressVisible", false);
    });
  },
  beforeDestroy() {},
  destroyed() {},

  data() {
    return {
      searchTitle: "",
      allDataList: [],
      payload: {
        items: [],
        columns: []
      },
      searchKeys: {
        firstName: "",
        lastName: "",
        userType: "",
        phoneNumber: ""
      },
      helper: {
        isColumnRendered: false,
        selectedLimitIndex: this.$mcdStore.get("limitIndex")
      },
      options: {
        current: 1,
        end: 0,
        maxResult: 0,
        limit: [10, 20, 50, 80, 100],
        sort: "-1"
      },
      error: {
        title: "Error!",
        message: "Something went wrong.",
        okText: "OK",
        cancelText: "CANCEL"
      }
    };
  },

  computed: {
    Items() {
      const { items } = this.payload;
      // console.log('items',items)
      // if (this.searchTitle !== "") {
      return items.filter(x => {
        return (
          x.email.toLowerCase().includes(this.searchTitle.toLowerCase()) ||
          String(x.totalLeads).includes(this.searchTitle.toLowerCase()) ||
          x.date.toLowerCase().includes(this.searchTitle.toLowerCase())
        );
      });
      // } else {
      //   return this.payload.items;
      // }
    },
    Columns() {
      return this.payload.columns;
    },
    Current() {
      return this.options.current;
    },
    End() {
      return this.options.end;
    },
    MaxResult() {
      return this.options.maxResult;
    },
    Limit() {
      return this.options.limit;
    }
  },
  methods: {
    openDialog() {
      this.$refs.confirm_dailog.open();
    },
    closeDialog() {
      this.$refs.confirm_dailog.close();
    },
    onOpen() {},
    onClose(type) {},
    //events
    onSort(e) {
      this.options.sort = e.name;
      this.getItems();
    },
    onPagination(e) {
      this.$store.dispatch("setIsProgressVisible", true);
      if (e) {
        this.getItems(e.page);
      } else {
        const { userPaging } = this.$store.getters;
        if (Object.keys(userPaging).length > 0) {
          const { next, current, end, total } = userPaging;
          this.options.maxResult = total;
          this.options.current = current;
          this.options.end = this.options.limit[this.helper.selectedLimitIndex];
          this.$store.dispatch("setIsProgressVisible", false);
        }
      }
    },
    onSizeChange(e) {
      this.$mcdStore.set("limitIndex", this.options.limit.indexOf(parseInt(e)));
      this.helper.selectedLimitIndex = this.$mcdStore.get("limitIndex");
      this.getItems(this.options.current, () => {
        this.$store.dispatch("setIsProgressVisible", true);
      });
    },
    edit(e, item) {
      this.$router.push({
        path: "/editUser",
        name: "Edit User",
        params: {
          user_id: item._id,
          item: item
        }
      });
    },
    getItems(pageNumber = 1, callback = null) {
      const { limit, sort } = this.options;
      const { selectedLimitIndex } = this.helper;
      const search = Object.assign({}, this.searchKeys);
      const options = {
        page: pageNumber,
        limit: this.options.limit[this.$mcdStore.get("limitIndex")],
        sort,
        search
      };
      makeRequest("/admin/excelsheetlog", "GET", null, options)
        .then(result => {
          let res = result.res;
          this.$store.dispatch("setIsProgressVisible", false);

          if (res.data.status === "403") {
            this.error.title = "Error!";
            this.error.message = res.data.message;
            this.openDialog();
          }
          if (!result.error && res) {
            if (res.data.status === "403") {
              this.error.message = res.data.message;
              this.openDialog();
            }
            // this.$store.dispatch("setUserItems", res.data);
            // this.payload.items = res.data.data;

            //
            const dataarray = ["email", "totalLeads", "date"];
            let temparr = [];
            res.data.data.map(x => {
              let value = {};
              dataarray.map((y, index) => {
                value[y] = x[y] !== undefined || x[y] !== null ? x[y] : "null";
                if (index == dataarray.length - 1) {
                  temparr.push(value);
                }
              });
            });
            this.allDataList = temparr;
            this.payload.items = temparr;
            //

            this.onPagination(null);
          }
        })
        .catch(reject => {
          this.$store.dispatch("setIsProgressVisible", false);
          this.error.title = "Error!";
          this.error.message = "Something went wrong! Please try again laster.";
          this.openDialog();
        });
    }
  },
  updated() {
    this.$store.dispatch("setIsProgressVisible", false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/view/offerUsersList/offerUserList.vue